import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider, createRoutesFromElements, Route } from 'react-router-dom';
import * as Navigation from "./modules/Navigation";
import DashboardPage from './components/app/pages/DashboardPage';
import InventoryPage from './components/app/pages/InventoryPage';
import ViewPage from './components/app/pages/ViewPage';
import CreatePage from './components/app/pages/CreatePage';
import EditPage from './components/app/pages/EditPage';
import CreateRecallsPage from './components/app/pages/CreateRecallsPage';
import EstablishmentsPage from './components/app/pages/EstablishmentsPage';
import CustomersPage from './components/app/pages/CustomersPage';
import AccountsPage from './components/app/pages/AccountsPage';
import OperatorsSettingsPage from './components/app/pages/OperatorSettingsPage';
import DocumentationPage from './components/app/pages/DocumentationPage';
import RecallsPickingPage from './components/app/pages/RecallsPickingPage';
import RecallsPackingPage from './components/app/pages/RecallsPackingPage';
import RequestsPage from './components/app/pages/RequestsPage';
import GlobalUsersPage from './components/app/pages/GlobalUsersPage';
import WorkstationsPage from './components/app/pages/WorkstationsPage';
import DisposalsPickingPage from './components/app/pages/DisposalsPickingPage';

// Helper to normalize paths (remove leading slash for nested routes)
const normalizePath = (path: string) => path.replace(/^\//, '');

// Create data router with all routes
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route index element={<DashboardPage />} />
      <Route path={normalizePath(Navigation.CreateRecalls.path)} element={<CreateRecallsPage />} />
      <Route path={normalizePath(Navigation.Establishments.path)} element={<EstablishmentsPage />} />
      <Route path={normalizePath(Navigation.Customers.path)} element={<CustomersPage />} />
      <Route path={normalizePath(Navigation.Accounts.path)} element={<AccountsPage />} />
      <Route path={normalizePath(Navigation.Inventory.path)} element={<InventoryPage />} />
      <Route path={normalizePath(Navigation.OperatorSettings.path)} element={<OperatorsSettingsPage />} />
      <Route path={normalizePath(Navigation.Documentation.path)} element={<DocumentationPage />} />
      <Route path={normalizePath(Navigation.view.path)} element={<ViewPage />} />
      <Route path={normalizePath(Navigation.create.path)} element={<CreatePage />} />
      <Route path={normalizePath(Navigation.edit.path)} element={<EditPage />} />
      <Route path={normalizePath(Navigation.editWithParent.path)} element={<EditPage />} />
      <Route path={normalizePath(Navigation.RecallsPicking.path)} element={<RecallsPickingPage />} />
      <Route path={normalizePath(Navigation.RecallsPacking.path)} element={<RecallsPackingPage />} />
      <Route path={normalizePath(Navigation.Requests.path)} element={<RequestsPage />} />
      <Route path={normalizePath(Navigation.Workstations.path)} element={<WorkstationsPage />} />
      <Route path={normalizePath(Navigation.DisposalsPicking.path)} element={<DisposalsPickingPage />} />
    </Route>
  )
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
    <RouterProvider router={router} />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
